import { Navigate, Route, Routes } from 'react-router-dom';

import { RootLayout } from '@/app/RootLayout';
import { isPlatformHost } from '@/config';
import LandingPage from '@/components/landing/LandingPage';
import PublicSite from '@/components/site/PublicSite';
import { AdminRoute } from '@/pages/AdminConsole';
import { PlatformConsole } from '@/pages/PlatformConsole';
import { AgenciesPage } from '@/pages/platform/AgenciesPage';
import { AgencyPage } from '@/pages/platform/AgencyPage';
import { AgencySiteBuilderPage } from '@/pages/platform/AgencySiteBuilderPage';
import { AgencyStaffPage } from '@/pages/platform/AgencyStaffPage';
import { NewAgencyPage } from '@/pages/platform/NewAgencyPage';
import { OverviewPage } from '@/pages/platform/OverviewPage';
import { PlansPage } from '@/pages/platform/PlansPage';
import { ProfilePage } from '@/pages/platform/ProfilePage';
import { SettingsPage } from '@/pages/platform/SettingsPage';
import { PlatformUsersPage } from '@/pages/platform/PlatformUsersPage';
import ConfirmEmailPage from '@/pages/ConfirmEmailPage';
import InviteAcceptPage from '@/pages/InviteAcceptPage';
import LoginPage from '@/pages/LoginPage';
import NotFoundPage from '@/pages/NotFoundPage';
import SignPage from '@/pages/SignPage';

// Route table mirroring the Next.js App Router structure.
//
// Apex / www serve the SaaS landing page. Agency hosts serve the public site.
// Staff reach /login → /super-admin (platform) or /admin (agency).
export default function App() {
  const platform = isPlatformHost();

  return (
    <RootLayout>
      <Routes>
        {platform ? (
          <>
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/confirm-email/:token" element={<ConfirmEmailPage />} />
            <Route path="/admin" element={<AdminRoute />} />
            <Route path="/admin/staff" element={<Navigate to="/admin?section=staff" replace />} />
            <Route path="/admin/profile" element={<Navigate to="/admin?section=profile" replace />} />
            <Route path="/super-admin" element={<PlatformConsole />}>
              <Route index element={<OverviewPage />} />
              <Route path="agencies" element={<AgenciesPage />} />
              <Route path="agencies/new" element={<NewAgencyPage />} />
              <Route path="agencies/:slug/site-builder" element={<AgencySiteBuilderPage />} />
              <Route path="agencies/:slug" element={<AgencyPage />} />
              <Route path="users" element={<PlatformUsersPage />} />
              <Route path="staff" element={<AgencyStaffPage />} />
              <Route path="audit" element={<Navigate to="/super-admin/settings/audit" replace />} />
              <Route path="plans" element={<PlansPage />} />
              <Route path="settings" element={<SettingsPage />} />
              <Route path="settings/:section" element={<SettingsPage />} />
              <Route path="profile" element={<ProfilePage />} />
              <Route path="*" element={<Navigate to="/super-admin" replace />} />
            </Route>
            <Route path="*" element={<NotFoundPage />} />
          </>
        ) : (
          <>
            <Route path="/" element={<PublicSite />} />
            <Route path="/vehicles" element={<PublicSite />} />
            <Route path="/vehicles/:id" element={<PublicSite />} />
            <Route path="/about" element={<PublicSite />} />
            <Route path="/contact" element={<PublicSite />} />
            <Route path="/faq" element={<PublicSite />} />
            <Route path="/locations" element={<PublicSite />} />
            <Route path="/deals" element={<PublicSite />} />
            <Route path="/services" element={<PublicSite />} />
            <Route path="/account" element={<PublicSite />} />
            <Route path="/legal/privacy" element={<PublicSite />} />
            <Route path="/legal/terms" element={<PublicSite />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/invite/:token" element={<InviteAcceptPage />} />
            <Route path="/confirm-email/:token" element={<ConfirmEmailPage />} />
            <Route path="/sign/:token" element={<SignPage />} />

            <Route path="/admin" element={<AdminRoute />} />
            <Route path="/admin/staff" element={<Navigate to="/admin?section=staff" replace />} />
            <Route path="/admin/profile" element={<Navigate to="/admin?section=profile" replace />} />

            {/* Custom single-segment builder pages, e.g. /fleet. */}
            <Route path="/:slug" element={<PublicSite />} />

            <Route path="*" element={<NotFoundPage />} />
          </>
        )}
      </Routes>
    </RootLayout>
  );
}
